<app-map (onMapClose)="closeCard()" [mapInitialized]="_mapInitialized" [hasErrorLoadingMap]="_errLoadingMap" [isCard]="true">
  <div class="flex justify-between items-center">
    <mot-autocomplete #mapContainer #autocomplete [formControl]="formControl" fieldClass="w-full px-2"
      [options]="results$" [displayFn]="routePlanningService.displayAddressName" [placeholder]="searchAddressText"
      (onOptionSelected)="onStationSelected($event)" class="station-autocomplete h-12 flex top-4 w-full absolute z-50"
      [hasTrigger]="true">
      <ng-template #customOption let-option>
        <div class="flex gap-2 items-center">
          <div class="flex flex-col flex-1">
            @if (option.value.addressDetails?.label) {
              <span class="text-[13px]">{{
                option.value.addressDetails.label
              }}</span>
            }
          </div>
        </div>
      </ng-template>
    </mot-autocomplete>
  </div>


  <div
    class="flex items-center gap-2 bg-darkBlue left-0 right-0 absolute mx-auto bottom-8 z-50 rounded-lg py-3 px-2 w-1/2">
    <ng-icon name="map-location-dot" class="text-white text-xl" />
    <span class="text-white">{{clickStationToSeeDetailsText}}</span>
  </div>
</app-map>